module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "epub:type": "dedication",
      "id": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("This book is dedicated to the brave missionary largely responsible for the original dissolution of the FARC and the 2016 Havana Peace Accords. God used this missionary to bring hundreds of FARC to Christ. With God in their hearts, killing became distasteful, and striking a peaceful resolution became their goal. Like Maggie, I appreciate God’s “subversive” nature‍—how He works through the humblest of hearts to make His Kingdom come.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-section-side-screen.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ornamental-break-as-text"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width dedication-content"
  }, [_c('i', [_vm._v("For everyone who lives in fear: You are not alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_c('i', [_vm._v("For those who protect the rest of us from fear: Thank you. Your reward is coming.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e332cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 63
// module chunks = 0